<template>
    <form @submit.prevent="personBasicInfo_Submit">
        <div class="card">
            <div class="card-header">
                个人基本信息管理
            </div>
            <div class="card-body">
                <div class="form-group row" :class="{'mb-0': !showDetailInfo}">
                    <label class="col-sm-2 col-form-label text-right" for="inputStudentName">姓名<span
                        class="text-danger">*</span></label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputStudentName" v-model="personBasicInfo.personName" :disabled="disableNameEdit">
                    </div>
                    <label class="col-sm-2 col-form-label text-right">性别<span class="text-danger">*</span></label>
                    <div class="col-sm-4" style="padding-top:calc(.375rem + 1px)">
                        <div class="form-check form-check-inline" v-for="code in genderEnumData" :key="code.codeValue">
                            <input class="form-check-input" type="radio" :id="'gender_' + code.codeValue"
                                   :value="code.codeValue" v-model="personBasicInfo.gender" :disabled="disableGenderEdit">
                            <label class="form-check-label" :for="'gender_' + code.codeValue">{{code.codeContent}}</label>
                        </div>
                    </div>
                </div>

                <div class="form-group row" v-if="showDetailInfo">
                    <label class="col-sm-2 col-form-label text-right" for="inputCardId">身份证号码<span
                        class="text-danger">*</span></label>
                    <div class="col-sm-4">
                        <input type="text" class="form-control" id="inputCardId" v-model="personBasicInfo.cardId"
                               :disabled="disableCardIdEdit" pattern="[0-9]{17}[0-9|x|X]{1}">
                    </div>
                    <label class="col-sm-2 col-form-label text-right" for="inputBirthdate">出生日期<span class="text-danger">*</span></label>
                    <div class="col-sm-4">
                        <input type="date" class="form-control" id="inputBirthdate" v-model="personBasicInfo.birthdateString" :disabled="disableBirthdateEdit">
                    </div>
                </div>

                <div class="form-group row" v-if="showDetailInfo">
                    <label class="col-sm-2 col-form-label text-right" for="inputNation">民族</label>
                    <div class="col-sm-4">
                        <select class="form-control" id="inputNation" v-model="personBasicInfo.nation">
                            <option :value="null">（请选择）</option>
                            <option v-for="code in nationEnumData" :key="code.codeValue" :value="code.codeContent">{{code.codeContent}}</option>
                        </select>
                    </div>
                    <label class="col-sm-2 col-form-label text-right" for="inputPoliticalOutlook">政治面貌</label>
                    <div class="col-sm-4">
                        <select class="form-control" id="inputPoliticalOutlook" v-model="personBasicInfo.politicalOutlook">
                            <option :value="null">（请选择）</option>
                            <option v-for="code in politicalOutlookEnumData" :key="code.codeValue" :value="code.codeContent">{{code.codeContent}}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group row" v-if="showDetailInfo">
                    <label class="col-sm-2 col-form-label text-right" for="inputEducation">学历</label>
                    <div class="col-sm-4">
                        <select class="form-control" id="inputEducation" v-model="personBasicInfo.education">
                            <option :value="null">（请选择）</option>
                            <option v-for="code in educationTypeEnum" :key="code.codeValue" :value="code.codeContent">{{code.codeContent}}</option>
                        </select>
                    </div>
                    <label class="col-sm-2 col-form-label text-right" for="inputDegree">学位</label>
                    <div class="col-sm-4">
                        <select class="form-control" id="inputDegree" v-model="personBasicInfo.degree">
                            <option :value="null">（请选择）</option>
                            <option v-for="code in degreeTypeEnum" :key="code.codeValue" :value="code.codeContent">{{code.codeContent}}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group row mb-0" v-if="showDetailInfo">
                    <label class="col-sm-2 col-form-label text-right" for="inputMajor">专业</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="inputMajor" v-model="personBasicInfo.major" placeholder="专业">
                    </div>
                </div>
            </div>
            <div class="card-footer text-center">
                <button class="btn btn-primary" type="submit">保存</button>
            </div>
        </div>
    </form>
</template>

<script>
import baseApi from "@/utils/api/base";
import userApi from "@/utils/api/user";
export default {
    name: "OrganPersonBasicInfoEdit",
    props: {
        personId: {type: String, required: true},
        disableNameEdit: {type: Boolean, required: false, default: false},
        disableCardIdEdit: {type: Boolean, required: false, default: false},
        disableGenderEdit: {type: Boolean, required: false, default: false},
        disableBirthdateEdit: {type: Boolean, required: false, default: false},
        showDetailInfo: {type: Boolean, required: false, default: true},
    },
    data: function () {
        return {
            genderEnumData: [],
            nationEnumData: [],
            politicalOutlookEnumData: [],
            educationTypeEnum: [],
            degreeTypeEnum: [],
            personBasicInfo: {},
        };
    },
    mounted() {
        this.getGenderEnumData();
        this.getNationEnumData();
        this.getPoliticalOutlookEnum();
        this.getEducationTypeEnum();
        this.getDegreeTypeEnum();

        this.getPersonBasicInfo();
    },
    methods: {
        getGenderEnumData() {
            baseApi.codeValue.getUserGenderEnum().then(res => {
                this.genderEnumData = res.data;
            });
        },
        getNationEnumData() {
            baseApi.codeValue.getUserNationEnum().then(res => {
                this.nationEnumData = res.data;
            });
        },
        getPoliticalOutlookEnum() {
            baseApi.codeValue.getUserPoliticalOutlookEnum().then(res => {
                this.politicalOutlookEnumData = res.data;
            });
        },
        getEducationTypeEnum() {
            baseApi.codeValue.getUserEducationTypeEnum().then(res => {
                this.educationTypeEnum = res.data;
            });
        },
        getDegreeTypeEnum() {
            baseApi.codeValue.getUserDegreeTypeEnum().then(res => {
                this.degreeTypeEnum = res.data;
            });
        },

        getPersonBasicInfo() {
            userApi.person.basic.getOrganBasicInfo(this.personId).then(res => {
                this.personBasicInfo = res.data;
            });
        },

        personBasicInfo_Submit() {
            userApi.person.basic.updateOrganBasicInfo(this.personBasicInfo).then(res => {
                this.personBasicInfo = res.data;
                alert('个人基本信息已保存！');
            });
        }
    }
}
</script>

<style scoped>

</style>